module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/my-home-illustration-59f13ba570e9abfc7a11f12b088d2689.svg";